import React, { useMemo } from "react";

import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

import useGlobalLoading from "src/redux/hooks/useGlobalLoading";

import LoadingSpinner from "../LoadingSpinner";

/**
 * Smart Loading Spinner Component - Optimized Version
 *
 * Following studio pattern for strategic loading state management.
 * Shows loading spinner only when appropriate based on route and loading state.
 */
const SmartLoadingSpinner = ({ children }) => {
  const { loading: initialLoading } = useGlobalLoading();
  const location = useLocation();

  // Memoize route checking to prevent unnecessary re-renders
  const shouldShowSpinner = useMemo(() => {
    if (!initialLoading) return false;

    // Routes that should not show loading spinner
    const routesWithoutSpinner = [
      "/auth/login",
      "/auth/signup",
      "/404",
    ];

    return !routesWithoutSpinner.includes(location.pathname);
  }, [initialLoading, location.pathname]);

  if (shouldShowSpinner) {
    return <LoadingSpinner />;
  }

  return children;
};

SmartLoadingSpinner.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SmartLoadingSpinner;
